export const MIME_TYPES = {
  JSON: 'application/json',
  FORM_DATA: 'multipart/form-data',
}

export const RESPONSE_TYPE = {
  JSON: 'json',
  BLOB: 'blob',
}